import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceDetectionService {
  private hasUaMobileSignal(): boolean {
    const uaData = (navigator as any).userAgentData;
    if (uaData && uaData.mobile === true) return true;

    const ua = navigator.userAgent || '';
    if (/iPhone|iPod|Android.+Mobile|Windows Phone|IEMobile|Opera Mini/i.test(ua)) {
      return true;
    }

    // iPadOS can report as MacIntel; touch points disambiguate.
    if (/iPad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      return true;
    }

    return false;
  }

  isDesktop(): boolean {
    const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
    const hasHover = window.matchMedia('(hover: hover)').matches;
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const longEdge = Math.max(window.innerWidth || 0, window.innerHeight || 0);
    const largeViewport = longEdge >= 1024;

    if (this.hasUaMobileSignal()) return false;

    // Gate only when signals strongly indicate desktop/laptop.
    if (hasFinePointer && hasHover && largeViewport && !hasCoarsePointer) {
      return true;
    }

    // Ambiguous devices default to mobile pass-through.
    return false;
  }

  shouldShowMobileGate(): boolean {
    return this.isDesktop();
  }
}
